module.exports = __webpack_public_path__ + "static/media/beneficios_vertical.b730c119.png";